import React from "react";

export default function Container({ styles, children }) {

    return (
        <div className={`2xl:max-w-[1440px] xl:max-w-[1220px] px-[1.25rem] w-full mx-auto ${styles}`}>
            {children}
        </div>
    )
}